import Vuex from "vuex";
import Vue from "vue";
import store from "@/store";
import { shallowMount, createLocalVue } from "@vue/test-utils";
import ABTesting from "@/plugins/ab-testing";

const localVue = createLocalVue();
localVue.use(Vuex);
localVue.use(ABTesting);

describe("AB Testing plugin", () => {
  let Component;
  let wrapper;

  beforeEach(() => {
    jest.spyOn(ABTesting, "install");
    jest.spyOn(ABTesting, "applyAbTestExperience");

    Component = Vue.component("test-component", {
      data: () => ({}),
      mounted() {},
      template: "<div>{{this.adobeTargetExperience}}</div>"
    });

    wrapper = shallowMount(Component, {
      localVue
    });
  });

  afterEach(() => {
    jest.clearAllMocks();
  });

  it("ABTesting configuración install()", () => {
    store.state.route = {
      name: "testRoute"
    };
    store.state.adobeTargetExperience = "testExperience";
    ABTesting.install();
    const installMock = jest.spyOn(ABTesting, "install");
    expect(installMock).toHaveBeenCalledTimes(1);
  });

  it("ABTesting configuración applyAbTestExperience() experience empty", () => {
    const experience = "";
    const route = "";
    ABTesting.applyAbTestExperience(experience, route);
    const applyAbTestExperienceMock = jest.spyOn(
      ABTesting,
      "applyAbTestExperience"
    );
    expect(applyAbTestExperienceMock).toHaveBeenCalledTimes(1);
  });

  it("Configuración exportada por defecto al instalarse", () => {
    expect(wrapper).toBeDefined();
    expect(wrapper).not.toBeNull();
    expect(typeof wrapper).toBe("object");
  });
});
